export const _GET_SCRIPTS = '_GET_SCRIPTS';

export const _ADD_SCRIPTS = '_ADD_SCRIPTS';

export const _DEL_SCRIPTS = '_DEL_SCRIPTS';

export const _UPDATE_SCRIPTS = '_UPDATE_SCRIPTS';
